import { Plugin } from "@tiptap/pm/state";

// Closers only. A straight `"` also opens a quote ("Hi @First Name "VIP""), so
// it keeps the space; `'` is here for the possessive ("@Clinic Name's").
const PUNCTUATION = /^[,.!?;:)'’”]$/;

/**
 * A variable is inserted with a trailing space so the next word doesn't run
 * into it. Punctuation typed straight after takes that space's place, so
 * "Hi @First Name," doesn't send as "Hi Megan , ...".
 */
export function punctuationAfterMention(mentionTypeName: string) {
  return new Plugin({
    props: {
      handleTextInput(view, from, to, text) {
        if (from !== to || from < 2 || !PUNCTUATION.test(text)) return false;
        const { doc } = view.state;
        if (doc.textBetween(from - 1, from) !== " ") return false;
        if (doc.resolve(from - 1).nodeBefore?.type.name !== mentionTypeName) {
          return false;
        }
        view.dispatch(view.state.tr.insertText(text, from - 1, from));
        return true;
      },
    },
  });
}
